<template>
    <div>
        <modal
        class="new-modal-default"
        :name="modal_name"
        transition="nice-modal-fade"
        :delay="100"
        :width="800"
        :height="560"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="false"
        style="pointer-events:inherit !important" 
        v-bind:click-to-close="false"
        >
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div></div>
                    <div>
                        <span class="text-white fs-18 fw-600">COLUMN CONFIGURATION</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideSelf"></span>
                    </div>
                </div>
                <div class="v-modal-body">
                    <div class="v-modal-layout">
                        <div class="m-4">
                            <span class="text-center w-100 fs-15" style="color: #00448b;">Please select/deselect the check box in available columns to add/remove columns to the table</span>
                            <div class="d-flex justify-content-between mt-12 mb-8">
                                <div class="d-flex flex-column mx-5" style="width: 45%">
                                    <span class="w-100 text-center fs-18 mb-4" style="color: #504f4f;">Default Columns</span>
                                    <div class="d-flex flex-column p-3" style="border: 1px solid  rgb(150, 149, 149); border-radius: 5px;min-height: 21em;">
                                        <span class="fs-14 fw-500" v-for="(config,index) in defaultConfigs" :key="index" style="color: rgb(150, 149, 149); margin-bottom: 15px;">{{config.value}}</span>
                                    </div>
                                </div>
                                <div class="d-flex flex-column mx-5" style="width: 45%">
                                    <span class="w-100 text-center fs-18 mb-4" style="color: #504f4f;">Available Columns</span>
                                    <div class="d-flex flex-column p-3" style="border: 1px solid  rgb(150, 149, 149); border-radius: 5px; min-height: 24em;">
                                        <span class="fs-14 fw-500 mb-2" v-for="(config,index) in availableConfigs" :key="index" style="color: #504f4f">
                                             <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;padding-top: 4px">
                                                <input
                                                    :value="config"
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    v-model="selected"
                                                />
                                                <span class="custom-control-indicator" style="font-size: 20px;top: -10px !important;"></span>
                                                <span class="form-check-description fw-600"></span>
                                            </label>
                                            {{config.value}}
                                        </span>
                                    </div>
                                </div>
                                <div class="d-flex flex-column justify-content-center mx-5" style="width: 10%">
                                    <button class="btn btn-des-small mb-2" style="background: #005dae; color: #fff;" @click="moveUp">
                                        <i class="icon-arrow-up text-white"></i>
                                    </button>
                                    <button class="btn btn-des-small mt-2" style="background: #005dae; color: #fff;" @click="moveDown">
                                        <i class="icon-arrow-down text-white"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="w-100 d-flex justify-content-center">
                                <button class="btn btn-des-small mr-4" style="background: #e82828; color: #fff; width: 7em" @click="hideSelf">Cancel</button>
                                <button class="btn btn-des-small" style="background: #128807; color: #fff; width: 11em" @click="saveColumnConfig">Apply and Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            defaultConfigs: [
                {
                    order: 1,
                    value: "Lead Name",
                },
                {
                    order: 2,
                    value: "Lead Source",
                },
                {
                    order: 3,
                    value: "Campaign Source",
                },
                {
                    order: 4,
                    value: "Date",
                },
                {
                    order: 5,
                    value: "Status",
                },
            ],
            availableConfigs: [
                {
                    order: 6,
                    value: "Lead Reference Type",
                },
                {
                    order: 7,
                    value: "Referred By",
                },
                {
                    order: 8,
                    value: "Location Introduced",
                },
                {
                    order: 9,
                    value: "Lead Type",
                },
                {
                    order: 10,
                    value: "Assigned To",
                },
                {
                    order: 11,
                    value: "Industry Type",
                },
            ],
            selected: [],
        }
    },
    props: ["modal_name"],
    methods: {
        hideSelf() {
            this.$modal.hide(this.modal_name);
        },
        move(arr, old_index, new_index) {
            while (old_index < 0) {
                old_index += arr.length;
            }
            while (new_index < 0) {
                new_index += arr.length;
            }
            if (new_index >= arr.length) {
                var k = new_index - arr.length;
                while ((k--) + 1) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            arr = arr.filter(x => x !== undefined);
            return arr;
        },
        moveUp() {
            this.selected.forEach((x,index) => {
                this.move(this.availableConfigs, index, index-1);
            });
            this.availableConfigs = this.availableConfigs.filter(x => x !== undefined);
        },
        moveDown() {
            this.selected.forEach((x,index) => {
                this.move(this.availableConfigs, index, index+1);
            });
            this.availableConfigs = this.availableConfigs.filter(x => x !== undefined);
        },
        async getColumnConfig() {
            let res = await this.$http.get("/user_column_config/?category=leads");
            if (res.data.status_id == 1) {
                res.data.response.leads.forEach((x,index) => {
                    if (index > 6) {
                        this.selected.push(x);
                    }
                });
            }
        },
        async saveColumnConfig() {
            let params = {
                leads: [],
            };
            this.defaultConfigs.forEach(x => {
                params.leads.push({
                    order: x.order,
                    value: x.value,
                });
            });
            if (this.selected.length) {
                this.selected.forEach(x => {
                    params.leads.push({
                        order: x.order,
                        value: x.value,
                    });
                });
            }

            let obj = {};
            for ( var i=0, len=params.leads.length; i < len; i++ ) {
                obj[params.leads[i]['order']] = params.leads[i];
            }
            params.leads = new Array();
            for ( var key in obj ) {
                params.leads.push(obj[key]);
            }
            let res = await this.$http.post("/user_column_config/add", params);
            if (res.data.status_id == 1) {
                this.$swal({
                    text: "Column Configuration Saved Successfully",
                    type: "success",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#005dae",
                }).then(() => {
                    this.$emit("coloumnLeadsUpdate")
                    this.hideSelf()
                });
            }
        }
    },
    created() {
        this.getColumnConfig();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ColumnConfigLeads.vue